export default "__VITE_ASSET__0f9fbf5e__"